import moment from "moment";

export const adaptDocumentosSearchExport = (documento) => {
    return {
        idEvaluacion: documento?.idEvaluacion,
        paciente: documento?.paciente,
        cliente: documento?.cliente,
        fechaDesde: (documento?.fechaDesde) ? moment(documento.fechaDesde).format('DD/MM/yyyy') : '' ,
        fechaHasta: (documento?.fechaHasta) ? moment(documento.fechaHasta).format('DD/MM/yyyy') : '' ,
        plan: documento?.modulo,
        cantCnx: documento?.cantCnx,
        cantCnxPE: documento?.cantCnxPE,
        cantCnxVE: documento?.cantCnxVE,
        aC: documento?.aC,
        eV: documento?.eV,
        c: documento?.c,
        rNH: documento?.rNH,
        rFK: documento?.rFK,
        p: documento?.p,
        v: documento?.v,
        dOC: documento?.dOC,
        pE: documento?.pE,
        pG: documento?.pG,
        nT: documento?.nT,
        fN: documento?.fN,
        pS: documento?.pS,
        kN: documento?.kN,
        tOC: documento?.tOC,
        aS: documento?.aSS,
        pSI: documento?.pSI
    }
}

export const adaptDocumentosSearchExportArray = (
    documentos
) => {
    return structuredClone(documentos?.documentosSearch.valorEsperado)
        ?.map(documento => adaptDocumentosSearchExport(documento));
}